import * as React from 'react';
import {
  Box,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Draggable from 'react-draggable';

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

export default function CodeFormDialog({ type, open, handleClose, formik }) {


  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        fullWidth={true}
        maxWidth="sm"
      >
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          공통코드 {type === 'edit' ? '수정' : '추가'}
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Box
          component="form"
          sx={{
            display: 'flex',
            flexDirection: 'column',
          }}
          noValidate
          autoComplete="off"
          onSubmit={formik.handleSubmit}
        >
          <DialogContent dividers>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                '& > :not(style)': { mr: 1 },
              }}
            >
              <TextField
                margin="normal"
                required
                id="blcCd"
                name="blcCd"
                label="대분류코드"
                value={formik.values.blcCd}
                onChange={formik.handleChange}
                error={formik.touched.blcCd && Boolean(formik.errors.blcCd)}
                helperText={formik.touched.blcCd && formik.errors.blcCd}
              />
              <TextField
                margin="normal"
                id="mlcCd"
                name="mlcCd"
                label="중분류코드"
                value={formik.values.mlcCd}
                onChange={formik.handleChange}
                error={formik.touched.mlcCd && Boolean(formik.errors.mlcCd)}
                helperText={formik.touched.mlcCd && formik.errors.mlcCd}
              />
              <TextField
                margin="normal"
                id="slcCd"
                name="slcCd"
                label="소분류코드"
                value={formik.values.slcCd}
                onChange={formik.handleChange}
                error={formik.touched.slcCd && Boolean(formik.errors.slcCd)}
                helperText={formik.touched.slcCd && formik.errors.slcCd}
              />
            </Box>
            <TextField
              margin="normal"
              required
              fullWidth
              id="itemNm"
              name="itemNm"
              label="코드명"
              value={formik.values.itemNm}
              onChange={formik.handleChange}
              error={formik.touched.itemNm && Boolean(formik.errors.itemNm)}
              helperText={formik.touched.itemNm && formik.errors.itemNm}
            />

            <TextField
              margin="normal"
              fullWidth
              id="itemDesc"
              name="itemDesc"
              label="코드설명"
              value={formik.values.itemDesc}
              onChange={formik.handleChange}
              error={formik.touched.itemDesc && Boolean(formik.errors.itemDesc)}
              helperText={formik.touched.itemDesc && formik.errors.itemDesc}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              id="revVal1"
              name="revVal1"
              label="값1"
              value={formik.values.revVal1}
              onChange={formik.handleChange}
              error={formik.touched.revVal1 && Boolean(formik.errors.revVal1)}
              helperText={formik.touched.revVal1 && formik.errors.revVal1}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              id="revVal2"
              name="revVal2"
              label="값2"
              value={formik.values.revVal2}
              onChange={formik.handleChange}
              error={formik.touched.revVal2 && Boolean(formik.errors.revVal2)}
              helperText={formik.touched.revVal2 && formik.errors.revVal2}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              id="step"
              name="step"
              label="정렬순서"
              value={formik.values.step}
              onChange={formik.handleChange}
              error={formik.touched.step && Boolean(formik.errors.step)}
              helperText={formik.touched.step && formik.errors.step}
            />
            <FormGroup>
              <FormControlLabel
                id="useYn"
                name="useYn"
                label="사용"
                control={
                  <Checkbox
                    checked={formik.values.useYn}
                    onChange={formik.handleChange}
                  />
                }
              />
            </FormGroup>
          </DialogContent>
          <DialogActions>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              disabled={formik.isSubmitting}
            >
              저장
            </Button>
          </DialogActions>
        </Box>
      </Dialog>
    </div>
  );
}